import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import RenewalReportLayer from "../components/RenewalReportLayer";

const RenewalReportPage = () => {
  return (
    <MasterLayout>
      <RenewalReportLayer />
    </MasterLayout>
  );
};

export default RenewalReportPage;
